const PODImageType = {
    BASE64: 'base64',
    URL: 'url'
}

const courierService = {
    BLUEDART : 'bluedart',
    XPRESSBEES: 'xpressbees',
    DELHIVERY: 'delhivery'
}

module.exports = {
    PODImageType,
    courierService
};